import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import classnames from 'classnames/bind';
import style from './index.module.scss';
import {Dispatch} from 'redux';
import actions from '../../redux/actions';
import {ICoordinate, ILocation, IState, Replacement} from '../../interface';
import {Autocomplete} from '@react-google-maps/api';
import getCountryFromGeoCode from '../../utils/getCountryFromGeoCode';
import localesReplacement from '../../utils/localesReplacement';
import ReactCountryFlag from 'react-country-flag';

const cx = classnames.bind(style);

/* eslint-disable */
interface IProps {
  address: ILocation | undefined;
  setAddress: (value: ILocation | undefined) => void;
  position: ICoordinate;
  replacements: Replacement;
}

interface CountryWithISO {
  name: string | undefined;
  isoCode: string | undefined;
}

//Manual location component
const LocationSelection = React.memo(
  function _LocationSelection(props: IProps) {
    const {address, setAddress, position, replacements} = props;
    const [searchBox, setSearchBox] =
      useState<google.maps.places.Autocomplete>();
    const [location, setLocation] = useState<string | undefined>('');
    const [country, setcountry] = useState<CountryWithISO>();
    const window: any=globalThis;
    window.dataLayer = window.dataLayer || [];
    const onPlacesChanged = () => {
      if (searchBox) {
        const place = searchBox.getPlace();
        window.dataLayer.push({
          'event' : 'whereToBuyView',
          'pageType' : 'where to buy',
          'searchQuery' : place.formatted_address,
          'countryCode' :localStorage.getItem('countryCode')
        });
        place.formatted_address && setLocation(place.formatted_address);
        const country = _.find(place.address_components, (item) =>
          _.includes(item['types'], 'country'),
        );
        country &&
          setcountry({
            name: country?.long_name,
            isoCode: country?.short_name,
          });
        if (
          place.geometry?.location?.lat() &&
          place.geometry?.location?.lng()
        ) {
          setAddress({
            name: place.formatted_address,
            coordinate: {
              lat: place.geometry?.location?.lat(),
              lng: place.geometry?.location?.lng(),
            },
          });
        }
      }
    };
    const onSBLoad = (ref: google.maps.places.Autocomplete) => {
      setSearchBox(ref);
    };
    const autoSelect = (evt: React.KeyboardEvent<HTMLInputElement>) => {
      if (evt.key === 'Enter') {
        const firstResult = document.querySelector(
          '.pac-container .pac-item',
        )?.textContent;

        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({address: firstResult}, function (results, status) {
          if (status === google.maps.GeocoderStatus.OK && results) {
            results[0].formatted_address && setLocation(results[0].formatted_address);
            const country = _.find(results[0].address_components, (item) =>
              _.includes(item['types'], 'country'),
            );
            country &&
              setcountry({
                name: country?.long_name,
                isoCode: country?.short_name,
              });
            if (
              results[0].geometry?.location?.lat() &&
              results[0].geometry?.location?.lng()
            ) {
              setAddress({
                name: results[0].formatted_address,
                coordinate: {
                  lat: results[0].geometry?.location?.lat(),
                  lng: results[0].geometry?.location?.lng(),
                },
              });
            }
          }
        });
      }
    };
    //Get current country

    const setCountryFn = (
      results: google.maps.GeocoderResult[] | null,
      status: google.maps.GeocoderStatus,
    ) => {
      if (status === google.maps.GeocoderStatus.OK && results) {
        setcountry(getCountryFromGeoCode(results));
      }
    };

    useEffect(() => {
      const geocoder = new google.maps.Geocoder();
      if (address) {
        geocoder.geocode({location: address.coordinate}, setCountryFn);
      } else {
        geocoder.geocode({location: position}, setCountryFn);
        setLocation('');
      }
    }, [address, position]);
    useEffect(() => {
      window.dataLayer.push({
        'event' : 'whereToBuyView',
        'pageType' : 'where to buy',
        'countryCode' :localStorage.getItem('countryCode')
      });
      if (address) {
        setLocation(address.name);
      }
    }, []);
    //
    //Get Flag from ISOcode of country
    return (
      <div className={cx('location-selection')}>
        {country?.name && (
          <>
            <div className={cx('flag')}>
              <ReactCountryFlag
                style={{
                  display: 'block',
                  width: '24px',
                  height: '16px',
                }}
                svg
                countryCode={country?.isoCode as string}
              />
            </div>
            <div className={cx('dropdown')}>
              <strong>{localesReplacement(replacements, country?.name)}</strong>
              <div className={cx('input-with-close')}>
                <Autocomplete
                  onLoad={onSBLoad}
                  onPlaceChanged={onPlacesChanged}
                  options={{types: ['geocode']}}
                >
                  <input
                    type='text'
                    value={location}
                    onChange={(evt) => setLocation(evt.target.value)}
                    onKeyDown={(evt) => autoSelect(evt)}
                    placeholder={localesReplacement(
                      replacements,
                      'Search address',
                    )}
                  />
                </Autocomplete>
              </div>
            </div>
            <i
              className={cx('position')}
              onClick={() => {
                setAddress(undefined);
                setLocation('');
                const geocoder = new google.maps.Geocoder();
                geocoder.geocode(
                  {location: position},
                  function (results, status) {
                    if (status === google.maps.GeocoderStatus.OK) {
                      if (results) {
                        setcountry(getCountryFromGeoCode(results));
                      }
                    }
                  },
                );
              }}
            ></i>
          </>
        )}
      </div>
    );
  },
  (prev, next) => {
    return _.isEqual(prev, next) ? true : false;
  },
);

const mapStateToProps = (state: IState) => ({
  address: state.filter.address,
  replacements: state.replacements,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setAddress: (value: ILocation | undefined) =>
    dispatch(actions.setAddress(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LocationSelection);
